export const variablesForScrollling = {
  scrollDelayTime1000: 1000,
  scrollDelayTime600: 600,
  scrollDelayTime500: 500,
  normalCardWidth: 320,
  bigCardWidth: 480,
  paddingBetween: 15,
  screenSize: 768,
}
